import { post, get } from 'axios/index';
import Core6RowNudging from './Core6RowNudging';
import * as CUSTOMEVENTS from './Core6Events';
import Core6RowGUIUpdater from './Core6RowGUIUpdater';
import Core6Utilities from './Core6Utilities';
import Core6Config from './Core6Config';
import Core6Component from './Core6Component';
import Core6BlockDragger from '../core6_dragger/Core6BlockDragger';
import Core6PagedSlider from './Core6PagedSlider';

export default class Core6RowAjax {
  static saveAfterNudge() {
    const rowList = document.querySelectorAll('.core6-mainrow-container:not(.isTemplate)');
    const orderedRows = [];
    for (let i = 0, rowLen = rowList.length; i < rowLen; i += 1) {
      orderedRows.push(rowList[i].getAttribute('data-row-id'));
    }

    const formData = new FormData();
    formData.append('ordered_rows', orderedRows);

    const config = Core6Config.getAjaxConfig();

    post('/api/blocks/nudge/save', formData, config)
      .then(() => {
        Core6RowNudging.refreshNudgeArrows();
      })
      .catch((error) => {
        console.error(error);
      });
  }

  static insertSlideAfter(inserAfterIndex, rowId) {
    const newSlide = Core6PagedSlider.getCurrentSlideIndex() + 1;
    console.log(`Insert after selected Slide: ${inserAfterIndex} on row: ${rowId}`);

    const config = Core6Config.getAjaxConfig();

    const formData = new FormData();
    formData.append('row_id', rowId);

    post('/api/pagedslider/insert', formData, config)
      .then((response) => {
        const previousBlock = Core6Utilities.getJQueryRowContainer(rowId);
        $(response.data.block_html).insertAfter(previousBlock);
        // Core6Utilities.replaceFullBlock(rowId, response.data.block_html);
        Core6PagedSlider.showPagedSliderBlockNumbers();
        Core6PagedSlider.showSlide(newSlide);
        Core6Utilities.refreshDialogs();
        Core6Utilities.refreshCSS();
        Core6BlockDragger.saveBlockOrdering();
      })
      .catch((error) => {
        console.error(error);
      });
  }

  static changeBlockType(rowId, destinationType) {
    const oldType = $(`.core6-mainrow-container[data-row-id="${rowId}"]:not(.isTemplate)`).attr('data-block-type');
    if (oldType === destinationType) {
      return;
    }

    const config = Core6Config.getAjaxConfig();

    const formData = new FormData();
    formData.append('row_id', rowId);
    formData.append('destination_type', destinationType);

    post('/api/blocks/changeType', formData, config)
      .then((response) => {
        Core6Utilities.replaceFullBlock(rowId, response.data.block_html);
        Core6Utilities.refreshDialogs();
        // Core6RowGUIUpdater.addDialog(response.data.row_dialogs);
        // Core6Utilities.modalCleanup();
      })
      .catch((error) => {
        console.error(error);
      });
  }

  static changeBlockAttributes(rowId, queue, isPagedSlider = false) {
    const paramData = {
      _method: 'POST',
      rowId,
      queue,
    };

    $.ajax({
      url: `/api/save_block_attributes?_=${new Date().getTime()}`,
      type: 'POST',
      data: paramData,
      beforeSend(xhr) {
        xhr.setRequestHeader('X-CSRF-TOKEN', $('meta[name="csrf-token"]').attr('content'));
        xhr.setRequestHeader('Authorization', `Bearer ${document.getElementById('API_TOKEN').value}`);
      },
      success(data) {
        if (isPagedSlider === true) {
          console.log(data);
          for (let i = 0; i < data.length; i += 1) {
            Core6Utilities.replaceFullBlock(data[i].row_id, data[i].html, false);
          }
        } else {
          Core6Utilities.replaceFullBlock(rowId, data);
        }
        Core6Utilities.refreshCSS();
        Core6Utilities.refreshDialogs();

        if (isPagedSlider === true) {
          Core6PagedSlider.initPagedSliders();
        }

        Core6Utilities.getElement('.core_loading_anim_container').style.display = 'none';
      },
    });
  }


  static changeBlockAttribute(rowId, param, value, resetSlider) {
    if (resetSlider === null || resetSlider === undefined) {
      resetSlider = false;
    }

    const formData = new FormData();
    formData.append('row_id', rowId);
    formData.append('param', param);
    formData.append('value', value);

    const config = Core6Config.getAjaxConfig();

    post('/api/save_row_attribute', formData, config)
      .then((response) => {
        switch (param) {
          case 'image':
            resetSlider = true;
            // console.log(`RowId: ${rowId} - image`);
            Core6RowGUIUpdater.updateParamImage(response.data);
            break;
          case 'transition':
            resetSlider = true;
            // console.log(`RowId: ${rowId} - transition`);
            Core6RowGUIUpdater.updateParamTransition(rowId, value, response.data);
            break;
          case 'scroll_numbers':
            resetSlider = true;
            // console.log(`RowId: ${rowId} - scroll_numbers`);
            Core6RowGUIUpdater.updateParamScrollNumbers(rowId, value, response.data);
            break;
          case 'scroll_arrows':
            resetSlider = true;
            // console.log(`RowId: ${rowId} - scroll_arrows`);
            Core6RowGUIUpdater.updateParamScrollArrows(rowId, value, response.data);
            break;
          case 'scroll_time':
            resetSlider = true;
            // console.log(`RowId: ${rowId} - scroll_time`);
            Core6RowGUIUpdater.updateParamScrollTime(rowId, value, response.data);
            break;
          case 'theme':
            // console.log(`RowId: ${rowId} - theme`);
            Core6RowGUIUpdater.updateParamTheme(rowId, value, response.data);
            break;
          case 'block_locked':
            // console.log(`RowId: ${rowId} - block_locked`);
            Core6RowGUIUpdater.updateParamBlockLocked(rowId, value);
            break;
          case 'container_background':
            // console.log(`RowId: ${rowId} - container_background`);
            Core6RowGUIUpdater.updateContainerBackground(rowId, value);
            break;
          case 'row_background':
            // console.log(`RowId: ${rowId} - row_background`);
            Core6RowGUIUpdater.updateRowBackground(rowId, value);
            break;
          case 'social_links_icon':
            // console.log(`RowId: ${rowId} - social_links_icon`);
            Core6RowGUIUpdater.updateColours(rowId, `[data-${param}]`, value);
            break;
          case 'title_font_colour':
            // console.log(`RowId: ${rowId} - title_font_colour`);
            Core6RowGUIUpdater.updateFontColour(rowId, `[data-${param}]`, value);
            break;
          case 'subtitle_font_colour':
            // console.log(`RowId: ${rowId} - subtitle_font_colour`);
            Core6RowGUIUpdater.updateFontColour(rowId, `[data-${param}]`, value);
            break;
          case 'upper_bar_background':
            // console.log(`RowId: ${rowId} - upper_bar_background`);
            Core6RowGUIUpdater.updateColours(rowId, `[data-${param}]`, value);
            break;
          case 'lower_bar_background':
            // console.log(`RowId: ${rowId} - lower_bar_background`);
            Core6RowGUIUpdater.updateColours(rowId, `[data-${param}]`, value);
            break;
          case 'upper_bar_font_colour':
            // console.log(`RowId: ${rowId} - upper_bar_font_colour`);
            Core6RowGUIUpdater.updateFontColour(rowId, `[data-${param}]`, value);
            break;
          case 'lower_bar_font_colour':
            // console.log(`RowId: ${rowId} - lower_bar_font_colour`);
            Core6RowGUIUpdater.updateFontColour(rowId, `[data-${param}]`, value);
            break;
          case 'social_links_background':
            // console.log(`RowId: ${rowId} - social_links_background`);
            Core6RowGUIUpdater.updateColours(rowId, `[data-${param}]`, value);
            break;
          case 'scrolldown_background':
            // console.log(`RowId: ${rowId} - scrolldown_background`);
            Core6RowGUIUpdater.updateColours(rowId, `[data-${param}]`, value);
            break;
          case 'scrollup_background':
            // console.log(`RowId: ${rowId} - scrollup_background`);
            Core6RowGUIUpdater.updateColours(rowId, `[data-${param}]`, value);
            break;
          case 'scrollup_icon':
            // console.log(`RowId: ${rowId} - scrollup_icon`);
            Core6RowGUIUpdater.updateColours(rowId, `[data-${param}]`, value);
            break;
          case 'scrolldown_icon':
            // console.log(`RowId: ${rowId} - scrolldown_icon`);
            Core6RowGUIUpdater.updateColours(rowId, `[data-${param}]`, value);
            break;
          case 'button_text_colour':
            // console.log(`RowId: ${rowId} - button_text_colour`);
            Core6RowGUIUpdater.updateFontColour(rowId, '[data-button_text_colour]', value);
            break;
          case 'button_background':
            // console.log(`RowId: ${rowId} - button_background`);
            Core6RowGUIUpdater.updateColour(rowId, '[data-button_background]', value);
            break;
          case 'min_height':
            Core6RowGUIUpdater.updateMinHeight(rowId, param, value);
            break;
          case 'display_options':
            Core6Utilities.refreshCSS();
            break;
          case 'border_mode':
            Core6Utilities.refreshCSS();
            break;
          case 'border_top_height':
            Core6Utilities.refreshCSS();
            break;
          case 'border_top_style':
            Core6Utilities.refreshCSS();
            break;
          case 'border_bottom_height':
            Core6Utilities.refreshCSS();
            break;
          case 'border_bottom_style':
            Core6Utilities.refreshCSS();
            break;
          case 'border_bottom_colour':
            Core6Utilities.refreshCSS();
            break;
          case 'border_top_colour':
            Core6Utilities.refreshCSS();
            break;
          case 'link_colour':
            Core6Utilities.replaceLoader(rowId, response.data);
            break;
          case 'link_hover_colour':
            Core6Utilities.replaceLoader(rowId, response.data);
            break;
          case 'horizontal_align':
            Core6Utilities.replaceLoader(rowId, response.data);
            break;
          case 'vertical_align':
            Core6Utilities.replaceLoader(rowId, response.data);
            break;
          case 'image_mode':
            Core6Utilities.replaceLoader(rowId, response.data);
            break;
          case 'remove_bootstrap_padding':
            Core6Utilities.replaceLoader(rowId, response.data);
            break;
          case 'row_type':
            Core6RowGUIUpdater.changeRowType(rowId, value);
            break;
          case 'mobile_menu_icon_background_colour':
            // console.log(`RowId: ${rowId} - mobile_menu_icon_background_colour`);
            Core6RowGUIUpdater.updateColour(rowId, `[data-${param}]`, value);
            break;
          case 'mobile_menu_icon_colour':
            // console.log(`RowId: ${rowId} - mobile_menu_icon_colour`);
            Core6RowGUIUpdater.updateColour(rowId, `[data-${param}]`, value);
            break;
          case 'mobile_company_name_colour':
            // console.log(`RowId: ${rowId} - mobile_company_name_colour`);
            Core6RowGUIUpdater.updateFontColour(rowId, `[data-${param}]`, value);
            break;
          default:
            Core6RowGUIUpdater.genericParams(rowId, param, value, response.data);
            break;
        }

        if (resetSlider === true) {
          document.querySelector('body').dispatchEvent(CUSTOMEVENTS.RESET_SLIDER);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  static changeColumnCount(rowId, columns) {
    $(`.changeRowColumnsModal[data-row-id=${rowId}]`).modal('hide');
    $('.active[data-core6-action="changeColumnCount"]').removeClass('active');

    const config = Core6Config.getAjaxConfig();

    const formData = new FormData();
    formData.append('row_id', rowId);
    formData.append('columns', columns);

    post('/api/save_row_columns', formData, config)
      .then((response) => {
        $(`.core6-mainrow-container[data-row-id=${rowId}]:not(.isTemplate) .block_content_holder .inner_row`).replaceWith(response.data);
        $(`[data-core6-action="changeColumnCount"][data-row-id=${rowId}][data-columns="${columns}"]`).addClass('active');
        setTimeout(() => {
          document.dispatchEvent(CUSTOMEVENTS.COMPONENT_DELETED);
        }, 200);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  static refreshDialogs() {
    Core6Utilities.getElement('.core_loading_anim_container').style.display = 'flex';
    const config = Core6Config.getAjaxConfig();
    const pageId = Core6Utilities.getJQueryElement('body[data-core6-page-id]').attr('data-core6-page-id');
    console.log(`/api/getAllDialogs/${pageId}`);
    get(`/api/getAllDialogs/${pageId}`, config)
      .then((response) => {
        console.log('loaded dialogs...');
        const blockDialogContainer = Core6Utilities.getJQueryElement('#dialogContainer');
        blockDialogContainer.html(response.data.blockDialogs);

        const componentDialogContainer = Core6Utilities.getJQueryElement('#componentDialogContainer');
        componentDialogContainer.html(response.data.componentDialogs);

        const pageDialogContainer = Core6Utilities.getJQueryElement('#pageDialogContainer');
        pageDialogContainer.html(response.data.pageDialogs);

        setTimeout(Core6Component.initFeatureAndButtonUrls(), 100);
        setTimeout(Core6Utilities.initICheck(), 100);
        setTimeout(Core6Utilities.initDialogTabs(), 100);
        setTimeout(Core6PagedSlider.disableNewPagedSlidersIfNeeded(), 100);

        Core6Utilities.getElement('.core_loading_anim_container').style.display = 'none';
      })
      .catch((error) => {
        alert('Error loading dialogs, please refresh.');
        console.error(error);
      });
  }

  static deleteAllPagedSliders(rowId) {
    Core6Utilities.hideModal(`.confirmRowDeleteModal[data-row-id="${rowId}"]`);

    const allRowIds = [];
    const allRows = Core6Utilities.getElementAll('.core6-mainrow-container.pagedsliderblock');
    for (let i = 0; i < allRows.length; i += 1) {
      console.log(`delete: ${allRows[i].getAttribute('data-row-id')}`);
      allRowIds.push(allRows[i].getAttribute('data-row-id'));
      allRows[i].style.display = 'none';
    }
    console.log('Delete these: ');
    console.log(allRowIds);
    const rowIdsString = allRowIds.join('|');
    console.log(rowIdsString);

    const config = Core6Config.getAjaxConfig();

    const formData = new FormData();
    formData.append('rowIds', rowIdsString);

    post('/api/delete_rows', formData, config)
      .then(() => {
        // console.log(rowId);
        for (let i = 0; i < allRows.length; i += 1) {
          const itemToRemove = Core6Utilities.getRowContainer(allRows[i].getAttribute('data-row-id'));
          itemToRemove.remove();
        }

        Core6BlockDragger.saveBlockOrdering();
        Core6Utilities.refreshCSS();
        Core6Utilities.refreshDialogs();
        Core6RowNudging.refreshNudgeArrows();
      })
      .catch((error) => {
        console.error(error);
      });
  }

  static deleteRow(rowId) {
    Core6Utilities.hideModal(`.confirmRowDeleteModal[data-row-id="${rowId}"]`);

    const row = Core6Utilities.getRowContainer(rowId);

    let isPagedSlider = false;
    let prevSlideIndex = 0;
    if (row.classList.contains('pagedsliderblock')) {
      isPagedSlider = true;
      console.log(Core6PagedSlider.getCurrentSlideIndex());
      console.log(Core6PagedSlider.getCurrentSlideIndex() - 1);
      if (Core6PagedSlider.getCurrentSlideIndex() - 1 >= 0) {
        prevSlideIndex = Core6PagedSlider.getCurrentSlideIndex() - 1;
      }
    }
    row.style.display = 'none';

    const config = Core6Config.getAjaxConfig();

    const formData = new FormData();
    formData.append('row_id', rowId);

    post('/api/delete_row', formData, config)
      .then(() => {
        // console.log(rowId);
        const itemToRemove = Core6Utilities.getRowContainer(rowId);
        // console.log(itemToRemove);
        itemToRemove.remove();
        Core6BlockDragger.saveBlockOrdering();
        Core6Utilities.refreshCSS();
        Core6Utilities.refreshDialogs();
        Core6RowNudging.refreshNudgeArrows();

        if (isPagedSlider) {
          Core6PagedSlider.showPagedSliderBlockNumbers();
          Core6PagedSlider.showSlide(prevSlideIndex);
        }
        // Core6Utilities.modalCleanup();
      })
      .catch((error) => {
        console.error(error);
      });
  }

  static cloneRow(rowId) {
    console.log('Clone Row Clicked');

    Core6Utilities.hideModal(`.confirmRowCloneModal[data-row-id="${rowId}"]`);

    const config = Core6Config.getAjaxConfig();

    const formData = new FormData();
    formData.append('row_id', rowId);

    post('/api/clone_row', formData, config)
      .then((response) => {
        const row = Core6Utilities.getRowContainer(rowId);
        $(response.data.row_html).insertAfter(row);

        Core6BlockDragger.saveBlockOrdering();
        Core6Utilities.refreshCSS();
        Core6Utilities.refreshDialogs();
        Core6RowNudging.refreshNudgeArrows();
        setTimeout(() => {
          document.dispatchEvent(CUSTOMEVENTS.COMPONENT_DELETED);
          document.querySelector('body').dispatchEvent(CUSTOMEVENTS.RESET_SLIDER);
        }, 200);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  static cloneRowAndComponents(rowId) {
    $(`.confirmRowCloneModal[data-row-id=${rowId}]`).modal('hide');

    const config = Core6Config.getAjaxConfig();

    const formData = new FormData();
    formData.append('row_id', rowId);

    post('/api/clone_row_and_components', formData, config)
      .then((response) => {
        const row = Core6Utilities.getRowContainer(rowId);
        $(response.data).insertAfter(row);

        Core6BlockDragger.saveBlockOrdering();
        Core6Utilities.refreshCSS();
        Core6Utilities.refreshDialogs();
        Core6RowNudging.refreshNudgeArrows();
        setTimeout(() => {
          document.dispatchEvent(CUSTOMEVENTS.COMPONENT_DELETED);
          document.querySelector('body').dispatchEvent(CUSTOMEVENTS.RESET_SLIDER);
        }, 200);
      })
      .catch((error) => {
        console.error(error);
      });
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/core6/Core6RowAjax.js